<ng-container *ngIf="chatbot$ | async as chatbotState">
  <div
    class="messages-container"
    hfAutoScroll
    #auto="hfAutoScroll"
    [autoScrollThreshold]="80"
    [autoScrollBehavior]="'auto'"
    [class.full-screen_container]="chatbotState?.isFullScreen"
    (contentPainted)="onContentPainted()"
  >
    <ng-container *ngIf="showMainChatUI(chatbotState)">
      <span class="chat-main_messages_start-timestamp">{{
        chatbotState.conversationHistory.createdDate | date: mediumDate
      }}</span>

      <div [@fadeInMessages] (@fadeInMessages.done)="auto.forceScrollIfPinned()">
        <hf-messages-template
          *ngFor="let msg of chatbotState.uiMessageHistory"
          [message]="msg"
          [role]="msg.type"
        ></hf-messages-template>
        <ng-container *ngIf="chatbotThinking$ | async">
          <div class="dot-loader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="chatbotState?.isNewChatState">
      <section class="chatbot-main_messages-container_new-state">
        <hf-new-chat-template></hf-new-chat-template>
      </section>
    </ng-container>
    <ng-container *ngIf="chatbotState?.isWarningState">
      <section class="chatbot-main_messages-container_warning-state">
        <hf-warning-template></hf-warning-template>
      </section>
    </ng-container>
    <!-- error state -->
    <section *ngIf="chatbotState?.latestError as err" class="chatbot-error">
      <p>{{ err }}</p>
      <button type="button" class="btn btn-lrg button-primary" (click)="retryLoad()">Try again</button>
    </section>
  </div>
  <!-- Loading state-->
  <div *ngIf="uiRendering && showLoadingIndicator(chatbotState)" class="ui-render-loading">
    <hf-loading-spinner ariaLabel="Loading chat..." />
    <span>Loading chat...</span>
  </div>
</ng-container>
